import { Components } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import { actions, useAppDispatch, useAppSelector } from "../../../redux";
import { FlexRow } from "../../Common/Styles";

export const SelectedIndustries = () => {
  const dispatch = useAppDispatch();
  const { industries } = useAppSelector((state) => state.onboarding);

  if (!industries || !industries.length) return null;
  return (
    <Container $gapInPx={16}>
      {industries.map((industry, index) => (
        <Components.Chip
          key={`${industry.id}-${index}`}
          content={industry.title}
          kind="Primary"
          showCloseIcon
          onClose={() => {
            dispatch(actions.onboarding.removeIndustry(industry));
          }}
        />
      ))}
    </Container>
  );
};

const Container = styled(FlexRow)`
  flex-flow: row;
  flex-wrap: wrap;
`;
